// extracted by mini-css-extract-plugin
export default {"info":"VaxqkSIfUnPpSk6scZW7","dissapear":"Z1FenFwH6aJl5R0y2Lg1","alert":"hgVF87rPQCHW2hjXXI6f","platform":"rZfiKJI_C8e9kjV65qqX","exports":"nnaRRQgJ0gYjuXbf39bK"};